const comments = [
  {
    name: '追剧小达人',
    time: '3天前',
    content: '真的太方便了，之前到处找西瓜视频免费资源都要下载各种APP，现在直接在糖心视频上就能看，高清不缓冲，每天午休追一集韩剧，幸福感拉满！',
    likes: '236',
  },
  {
    name: '电影爱好者老张',
    time: '5天前',
    content: '朋友推荐的这个免费视频网站，没想到资源这么全。最近热门的国产剧和好莱坞大片都有，4K画质真的惊艳，而且完全免费，已经安利给全家人了。',
    likes: '189',
  },
  {
    name: '二次元阿宅',
    time: '1周前',
    content: '追番党的福音啊！新番更新速度很快，画质也好。之前91在线视频的番剧资源在这边也能找到，再也不用在好几个网站之间来回切换了。',
    likes: '157',
  },
  {
    name: '深夜追剧人',
    time: '1周前',
    content: '每天晚上睡前必刷糖心视频，纪录片频道太赞了。最近在补《地球脉动III》，高清画质加不缓冲的流畅体验，比付费平台还好用，强烈推荐！',
    likes: '203',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="relative py-16 md:py-24 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100/70 text-primary-700 text-xs font-semibold mb-4">
            真实声音
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            用户评价
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            听听糖心视频用户们的真实观影感受
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {comments.map((item) => (
            <div
              key={item.name}
              className="bg-background-100 rounded-xl p-6 md:p-7"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-primary-100/60 flex items-center justify-center text-primary-600 font-heading font-bold text-sm shrink-0">
                  {item.name.charAt(0)}
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-800">{item.name}</div>
                  <div className="text-xs text-foreground-400">{item.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                {item.content}
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line text-accent-500"></i>
                <span>{item.likes} 人觉得有用</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}